export const NAMESPACE = 'mediavine-video'

export const ACTIVE_ID = 'active-id'

export const PLAYLIST_POSITION = 'playlist-position'
export const PLAYLIST_POSITION_EXPIRES = 15 // 15 minutes

export const AUTOPLAY_DISABLED = 'autoplay-disabled'
export const AUTOPLAY_DISABLED_EXPIRES = 60 // 60 minutes
